/**
 * Метод для получения ID - операторов из массива отельных продуктов.
 */

import _ from 'underscore';

const prepareOperatorsIdsFromHotelOfferProducts = (hotelOfferProducts) => {
    const operatorsIds = _.reduce(hotelOfferProducts, (acc, hotelOfferProduct) => {
        const operatorId = hotelOfferProduct?.operator?.id || hotelOfferProduct?.hotelOffer?.get('operator')?.id;
        if (operatorId && !acc.some((id) => id !== operatorId)) acc.push(operatorId);
        return acc;
    }, []);

    return _.uniq(operatorsIds);
};

export default prepareOperatorsIdsFromHotelOfferProducts;
